import { Card } from '../ui/Card';
import { Field } from '../ui/Field';
import { PhiProvider } from '../../contexts/PhiContext';
import { LoadingSpinner } from '../LoadingSpinner';

// Fields rendered on the Member Details tab. All four are PHI per the Data
// Dictionary; the backend nulls them and lists them in phi_masked_fields for
// users without PHI access. <Field> reads the same mask context and renders
// asterisks automatically.
const FIELDS = [
  { name: 'member_name', label: 'Name' },
  { name: 'birth_date', label: 'Birth Date' },
  { name: 'member_id', label: 'Member ID' },
  { name: 'subscriber_id', label: 'Subscriber ID' },
];

function MemberDetailsTab({ identifiers, phiMaskedFields, loading = false, error = null }) {
  if (loading) {
    return (
      <div className="member-details-center-container" data-testid="member-details-center-container">
        <LoadingSpinner label="Loading member details" className="mx-auto" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="member-details-center-container" data-testid="member-details-center-container">
        <p className="member-details-error-text" data-testid="member-details-error-text">Failed to load member details.</p>
      </div>
    );
  }

  const safeIdentifiers = identifiers || {};
  const maskedFields = phiMaskedFields || [];

  return (
    <div className="member-details-container" data-testid="member-details-container">
      <Card className="member-details-card" data-testid="member-details-card">
        <PhiProvider maskedFields={maskedFields}>
          <div className="member-details-grid" data-testid="member-details-grid" style={{ gridTemplateColumns: `repeat(${FIELDS.length}, max-content)` }}>
            {FIELDS.map(({ name, label }) => (
              <div key={name} className="member-details-field-container" data-testid="member-details-field-container">
                <span className="member-details-field-label" data-testid="member-details-field-label">{label}</span>
                <Field
                  name={name}
                  value={safeIdentifiers[name]}
                  className="member-details-field-value"
                />
              </div>
            ))}
          </div>
        </PhiProvider>
      </Card>
    </div>
  );
}

export { MemberDetailsTab };
